import ceo from 'assets/images/main/visual.png';
import organizationImg from 'assets/images/company/company_chart.svg';
import mapImg from 'assets/images/company/map.jpg';
import visual from 'assets/images/company/visual.png';
import certification1 from 'assets/images/company/certification(1).png';
import certification2 from 'assets/images/company/certification(2).png';
import certification3 from 'assets/images/company/certification(3).png';
import certification4 from 'assets/images/company/certification(4).png';
import certification5 from 'assets/images/company/certification(5).png';
import certification6 from 'assets/images/company/certification(6).png';

export const krCompany = {
  title: `회사소개`,
  subTitle: `Company`,
  visual,
  subject1: '인사말',
  subject1Desc: 'CEO Message',
  ceoImg: ceo,
  ceoTitle: (
    <>
      인간과 공존할 수 있는
      <span>
        <br />
        축산 산업을 모색합니다.
      </span>
    </>
  ),
  ceoDesc: (
    <>
      주식회사 팜인은 인간과 공존할 수 있는 축산 산업의 모색을 위하여 악취로 인한 민원의 최소화 및 가축의 악취 관련
      스트레스 저감, 사양관리, 동물 복지 구현을 위한 기업입니다.
      <br />
      <br />
      관련하여 IT, BT, NT, ET 기반 기술의 다년간의 노하우 활성화 및 한국전자통신연구원 20년 연구 경력을 사업화에
      활용하고자 하는 기업입니다.
    </>
  ),
  subject2: `회사 약력`,
  subject2Desc: `Company History`,
  profileTitle: ``,
  profileDesc: [
    {
      year: `2023년`,
      items: [
        `06月 연구개발전담부서 인정 (팜인)`,
        `AQA 기술 개발 착수`,
        `11月 AEROQBIT 상표 등록`,
        `축사 환경 개선 기술 관련 특허 출원`,
        `  • 축사 내부 악취 저감 장치 및 방법 (출원번호 10-2023-0091811)`,
        `  • 기후에 따른 풍속 저감 장치 및 방법 (출원번호 10-2023-0079206)`,
        `  • 축사 내부 습도 조절 장치 (출원번호 10-2023-0157905)`,
        `  • 육류 유통 방법 (출원번호 10-2023-016759)`,
      ],
    },
    {
      year: `2024년`,
      items: [
        `AQA 시스템 고도화 및 현장 설치`,
        `실증 환경 기반 데이터 수집 및 성능 검증`,
        `스마트 축사 환경 제어 기술 적용 확대`,
      ],
    },
    {
      year: `2025년`,
      items: [
        `AQD 기술 개발 완료`,
        `실제 농장 대상 AQD 시스템 배포`,
        `현장 운영 데이터 기반 기술 개선 및 안정화`,
      ],
    },
    {
      year: `2026년`,
      items: [
        `AQD 현장 피드백 반영 고도화`,
        `스마트 축사 통합 솔루션 확장 및 상용화 추진`,
      ],
    },
  ],
  subject3: '조직도',
  subject3Desc: 'Organization',
  organizationImg,
  subject4: '특허',
  subject4Desc: 'Licensing',
  LicensingDesc: {
    text: `특허 출원으로 믿을 수 있는 산업을 제공하려 노력하고 있습니다.`,
    content: [
      { num: `출원번호 10-2023-0091811`, text: `축사 내부 악취 저감 장치 및 방법` },
      { num: `출원번호 10-2023-0079206`, text: `기후에 따른 풍속 저감 장치 및 방법 ` },
      { num: `출원번호 10-2023-0157905 `, text: `축사 내부 습도 조절 장치` },
      { num: `출원번호 10-2023-016759`, text: `육류유통방법` },
    ],
    certifications: [
      certification1,
      certification2,
      certification3,
      certification4,
      certification5,
      certification6,
    ],
  },
  subject5: '오시는 길',
  subject5Desc: 'Location',
  mapImg,
  address: `대전광역시 유성구 테크노9로 35, 407호(탑립동, 아이티전용벤처타운) [우 : 34027]`,
  tel: `042. 933. 9060`,
  fax: `042. 933. 9061`,
  email: `farmin0130@farm-in.kr`,
};

export const enCompany = {
  title: `회사소개_en`,
  subTitle: `Company`,
  visual,
  subject1: '인사말',
  subSubject1: 'CEO Message',
  ceoImg: ceo,
  ceoTitle: (
    <>
      인간과 공존할 수 있는
      <span>
        <br />
        축산 산업을 모색합니다.
      </span>
    </>
  ),
  ceoDesc: (
    <>
      주식회사 팜인은 인간과 공존할 수 있는 축산 산업의 모색을 위하여 악취로 인한 민원의 최소화 및 가축의 악취 관련
      스트레스 저감, 사양관리, 동물 복지 구현을 위한 기업입니다.
      <br />
      <br />
      관련하여 IT, BT, NT, ET 기반 기술의 다년간의 노하우 활성화 및 한국전자통신연구원 20년 연구 경력을 사업화에
      활용하고자 하는 기업입니다.
    </>
  ),
  subject2: `회사 약력`,
  subSubject2: `Company History`,
  profileTitle: ``,
  profileDesc: [
    {
      year: `2023년`,
      items: [
        `06月 연구개발전담부서 인정 (팜인)`,
        `AQA 기술 개발 착수`,
        `11月 AEROQBIT 상표 등록`,
        `축사 환경 개선 기술 관련 특허 출원`,
        `  • 축사 내부 악취 저감 장치 및 방법 (출원번호 10-2023-0091811)`,
        `  • 기후에 따른 풍속 저감 장치 및 방법 (출원번호 10-2023-0079206)`,
        `  • 축사 내부 습도 조절 장치 (출원번호 10-2023-0157905)`,
        `  • 육류 유통 방법 (출원번호 10-2023-016759)`,
      ],
    },
    {
      year: `2024년`,
      items: [
        `AQA 시스템 고도화 및 현장 설치`,
        `실증 환경 기반 데이터 수집 및 성능 검증`,
        `스마트 축사 환경 제어 기술 적용 확대`,
      ],
    },
    {
      year: `2025년`,
      items: [
        `AQD 기술 개발 완료`,
        `실제 농장 대상 AQD 시스템 배포`,
        `현장 운영 데이터 기반 기술 개선 및 안정화`,
      ],
    },
    {
      year: `2026년`,
      items: [
        `AQD 현장 피드백 반영 고도화`,
        `스마트 축사 통합 솔루션 확장 및 상용화 추진`,
      ],
    },
  ],
  subject3: '조직도',
  subSubject3: 'Organization',
  organizationImg,
  subject4: '특허',
  subSubject4: 'Licensing',
  LicensingDesc: {
    text: `특허 출원으로 믿을 수 있는 산업을 제공하려 노력하고 있습니다.`,
    content: [
      { num: `출원번호 10-2023-0091811`, text: `축사 내부 악취 저감 장치 및 방법` },
      { num: `출원번호 10-2023-0079206`, text: `기후에 따른 풍속 저감 장치 및 방법 ` },
      { num: `출원번호 10-2023-0157905 `, text: `축사 내부 습도 조절 장치` },
      { num: `출원번호 10-2023-016759`, text: `육류유통방법` },
    ],
    certifications: [
      certification1,
      certification2,
      certification3,
      certification4,
      certification5,
      certification6,
    ],
  },
  subject5: '오시는 길',
  subSubject5: 'Location',
  mapImg,
  address: `대전광역시 유성구 테크노9로 35, 407호(탑립동, 아이티전용벤처타운) [우 : 34027]`,
  tel: `042. 933. 9060`,
  fax: `042. 933. 9061`,
  email: `farmin0130@farm-in.kr`,
};
